export const TAG = 'Header';

export const contextMenuItemIds = {
  coachMark: 'coach-mark',
  customiseDashboard: 'customise-dashboard',
};
